import { useEffect } from "react";
import PropTypes from "prop-types";
import { useForm, Controller } from "react-hook-form";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

RouteAccountDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  initial: PropTypes.object,
};

RouteAccountDialog.defaultProps = {
  initial: null,
};

const CURRENCIES = ["USD", "ZiG", "ZWL"];

export default function RouteAccountDialog({ open, onClose, onSave, initial }) {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      currency: "USD",
      accountNumber: "",
      accountName: "",
      swiftCode: "",
      branchCode: "",
      institutionId: "",
      isDefault: false,
    },
  });

  useEffect(() => {
    if (initial) {
      reset(initial);
    } else {
      reset({ currency: "USD", accountNumber: "", accountName: "", swiftCode: "", branchCode: "", institutionId: "", isDefault: false });
    }
  }, [initial, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{initial ? "Edit Account" : "Add Account"}</DialogTitle>
      <form onSubmit={handleSubmit(onSave)}>
        <DialogContent>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="currency-label">Currency *</InputLabel>
                <Controller
                  name="currency"
                  control={control}
                  render={({ field }) => (
                    <Select {...field} labelId="currency-label" label="Currency *">
                      {CURRENCIES.map((c) => (
                        <MenuItem key={c} value={c}>{c}</MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="accountNumber"
                control={control}
                render={({ field }) => (
                  <MDInput {...field} label="Account Number *" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="accountName"
                control={control}
                render={({ field }) => (
                  <MDInput {...field} label="Account Name" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="swiftCode"
                control={control}
                render={({ field }) => (
                  <MDInput {...field} label="Swift Code" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="branchCode"
                control={control}
                render={({ field }) => (
                  <MDInput {...field} label="Branch Code" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="institutionId"
                control={control}
                render={({ field }) => (
                  <MDInput {...field} label="Institution ID" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="isDefault"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={!!field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label="Set as Default for Currency"
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MDButton variant="outlined" color="secondary" onClick={onClose}>Cancel</MDButton>
          <MDButton type="submit" variant="gradient" color="info">{initial ? "Update" : "Add"}</MDButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}
